import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/Store';
import { switchAdminMenu } from '../../store/ActionAdmin';
import Loader from '../../components/Loader/Loader';
import {
  updatePrograma,
  uploadFile,
  createPrograma
} from '../../store/ActionProgramas';
import PageError from '../../components/PageError';
import { areas, municipios } from '../../utils/constantes';

export const AdminProgramaForm = () => {
  let fileInput = React.createRef();

  let formInit = {
    pregrado: '',
    descripcion: '',
    facultad: '',
    urlCaption: '',
    urlVideo: '',
    area: '',
    file: fileInput,
    fileName: '',
    regiones: [],
    urlUdea: '',
    valid: false,
    errors: []
  };

  const [form, setForm] = useState(formInit);

  const {
    state: {
      programaSelected,
      loadingImage,
      loading,
      uploadedImage,
      error,
      programas
    },
    dispatch
  } = useStore();

  useEffect(() => {
    if (programaSelected) {
      console.log(programaSelected);
      setForm({ ...form, ...programaSelected });
    }
  }, []);

  const handleClick = () => {
    switchAdminMenu(dispatch, 'programas');
  };
  const handleInput = e => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const handleSelectMultiple = e => {
    const { name, value } = e.target;

    const index = form[name].indexOf(value);
    if (index > -1) {
      setForm({
        ...form,
        [name]: [
          ...form[name].slice(0, index),
          ...form[name].slice(index + 1, form[name].length)
        ]
      });
    } else {
      setForm({
        ...form,
        [name]: [...form[name], value]
      });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (programaSelected) {
      updatePrograma(dispatch, programas, {
        id: programaSelected.id,
        pregrado: form.pregrado,
        descripcion: form.descripcion,
        facultad: form.facultad,
        urlCaption: uploadedImage ? uploadedImage : form.urlCaption,
        urlVideo: form.urlVideo,
        area: form.area,
        regiones: form.regiones,
        urlUdea: form.urlUdea
      });
    } else {
      createPrograma(dispatch, {
        pregrado: form.pregrado,
        descripcion: form.descripcion,
        facultad: form.facultad,
        urlCaption: uploadedImage ? uploadedImage : form.urlCaption,
        urlVideo: form.urlVideo,
        area: form.area,
        regiones: form.regiones,
        urlUdea: form.urlUdea
      });
    }
  };

  const handleImageSelection = e => {
    const file = e.target.files[0];
    setForm({ ...form, ['file']: file, ['fileName']: e.target.files[0].name });
  };

  const handleUpload = async e => {
    e.preventDefault();
    if (form.file && form.area) {
      await uploadFile(dispatch, form.file, form.area);
    }
  };

  return (
    <div>
      <form>
        <div className="form-group">
          <label htmlFor="pregrado">Pregrado</label>
          <input
            type="text"
            className="form-control"
            id="pregrado"
            name="pregrado"
            value={form.pregrado}
            onChange={handleInput}
            aria-describedby="Pregrado"
            placeholder="Pregrado"
          />
        </div>
        <div className="input-group mb-3">
          <div className="input-group-prepend">
            <label className="input-group-text" htmlFor="area">
              Área
            </label>
          </div>
          <select
            className="custom-select"
            id="area"
            name="area"
            onChange={handleInput}
            value={form.area}
          >
            {areas.map(ar => (
              <option key={ar.id} value={ar.id}>
                {ar.nombre}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <div className="input-group-prepend">
            <label className="input-group-text" htmlFor="regiones">
              Regiones
            </label>
          </div>
          <select
            className="custom-select"
            id="regiones"
            name="regiones"
            onChange={handleSelectMultiple}
            value={form.regiones}
            multiple
          >
            {municipios.map(mu => (
              <option
                key={mu.codigoDepartamento + mu.codigoMunicipio}
                value={mu.nombreMunicipio}
              >
                {mu.nombreMunicipio}
              </option>
            ))}
          </select>
        </div>
        <div className="Admin__regionesList">
          {form.regiones.map(municipio => (
            <p key={municipio}>{municipio}</p>
          ))}
        </div>

        <div className="form-group">
          <label htmlFor="facultad">Facultad</label>
          <input
            type="text"
            className="form-control"
            id="facultad"
            name="facultad"
            value={form.facultad}
            onChange={handleInput}
            aria-describedby="Ingresa Facultad"
            placeholder="Facultad"
          />
        </div>
        <div className="form-group">
          <label htmlFor="descripcion">Descripción</label>
          <textarea
            type="text"
            className="form-control"
            id="descripcion"
            name="descripcion"
            value={form.descripcion}
            onChange={handleInput}
            aria-describedby="Descripción"
            placeholder="Descripción"
            rows="4"
          />
        </div>
        <div className="form-group">
          <label>Imágen</label>
          <div className="Admin__caption">
            <img src={uploadedImage ? uploadedImage : form.urlCaption} />
          </div>
          <div className="input-group mb-3">
            <div className="custom-file">
              <input
                type="file"
                accept="image/*"
                className="custom-file-input"
                id="inputImage"
                onChange={handleImageSelection}
              />
              <label
                className="custom-file-label Admin__captionLabel"
                htmlFor="inputImage"
              >
                {form.fileName ? form.fileName : 'Seleccionar archivo'}
              </label>
            </div>
            <div className="input-group-append">
              <span className="input-group-text" onClick={handleUpload}>
                Subir
              </span>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="urlVideo">Video</label>
          <input
            type="text"
            className="form-control"
            id="urlVideo"
            name="urlVideo"
            value={form.urlVideo}
            onChange={handleInput}
            aria-describedby="Url del vídeo"
            placeholder="Url del vídeo"
          />
        </div>
        <div className="form-group">
          <label htmlFor="urlUdea">Enlace información institucional</label>
          <input
            type="text"
            className="form-control"
            id="urlUdea"
            name="urlUdea"
            value={form.urlUdea}
            onChange={handleInput}
            aria-describedby="Url de información institucional"
            placeholder="Url de del programa en udea.edu.co"
          />
        </div>
        {!loading ? (
          <div className="Login__buttons">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Guardar
            </button>
          </div>
        ) : (
          <Loader />
        )}
      </form>
      {error && <PageError error={error} />}
      {loadingImage && <Loader />}
      <button onClick={() => handleClick()} className="btn btn-secondary">
        Regresar
      </button>
    </div>
  );
};
